/**
 * Service worker registration helper.
 * Only runs in production build (dev CRA doesn't emit /service-worker.js).
 * Safe no-op on browsers without SW support.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Register on load so it doesn't fight with initial resource loading.
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Silent auto-update: reload once when a new SW takes control
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              // A new version is available — will apply on next reload.
              // Do NOT force reload silently; let the user finish their action.
              // console.log("New SW installed, will activate on next load.");
            }
          });
        });
      })
      .catch(() => {
        /* ignore — network offline on first load, will retry next visit */
      });
  });
}
